<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Video Player</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item active">Video List</li>
            </ol>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>

    <section class="content">
      <div class="container-fluid">
        <span> {{ currentUrl }}</span>
        <div class="row">
          <div class="col-md-8">
            <vue-plyr ref="plyr">
              <!-- 
             <video class="js-player" poster="poster.jpg"  autoplay controls playsinline preload="none" id="player1" data-plyr-config='{"volume": 0.7, "resetOnEnd": true, "enabled": true, "storage": { "enabled": false }, "quality": { "default": 360 } }'>
<source  src= "https://ghoorilearning.com/uploads/files/4e0cdcf5b15e6454a972cb8d699802cb.mp4" type="video/mp4" size="360">	
<source  :src= currentUrl type="video/mp4" size="720">
<source  :src= currentUrl type="video/mp4" size="1080">
</video> -->

              <video
                controls
                playsinline
                autoplay="true"
                data-plyr-config='{"volume": 0.5, "quality": { "default": 360 } }'
                 :src="currentUrl"
                                   type="video/mp4"

                class="videoSource"
              >
                <!-- <source
                  class="videoSource"
                  :src="currentUrl"
                  type="video/mp4"
                /> -->
            <!-- <source  class="videoSource" src= "https://ghoorilearning.com/uploads/files/4e0cdcf5b15e6454a972cb8d699802cb.mp4" type="video/mp4" size="360">	
            <source  :src= currentUrl type="video/mp4" size="720">
            <source  :src= currentUrl type="video/mp4" size="1080"> -->
           
              </video>
            </vue-plyr>
          </div>

          <div class="col-md-4">
            video list comes here.
            <ul>
              <li
                @click="
                  clickToPlay(
                    'https://ghoorilearning.com/uploads/files/4e0cdcf5b15e6454a972cb8d699802cb.mp4'
                  )
                "
              >
                1
              </li>
              <li
                @click="
                  clickToPlay(
                    'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-576p.mp4'
                  )
                "
              >
                2
              </li>
              <li
                @click="
                  clickToPlay(
                    'https://ghoorilearning.com/uploads/files/4e0cdcf5b15e6454a972cb8d699802cb.mp4'
                  )
                "
              >
                3
              </li>
              <li
                @click="
                  clickToPlay(
                    'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-576p.mp4'
                  )
                "
              >
                4
              </li>
              <li
                @click="
                  clickToPlay(
                    'https://ghoorilearning.com/uploads/files/4e0cdcf5b15e6454a972cb8d699802cb.mp4'
                  )
                "
              >
                5
              </li>
              <li @click="clickToPlay('https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-576p.mp4')">6</li>
            </ul>
          </div>
        </div>
        <!-- <plyr-video
          poster="path/to/poster.png"
          :videos="this.videos"
          :subtitles="this.subtitles"
          :crossorigin="true"
        /> -->
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from '@/components/layouts/MasterLayoutComponent.vue';
import localStorage from "@/services/localStorage";

export default {
  name: "MediaPlayer",
  metaInfo: {
    title: "MediaPlayer | Dotlines",
  },
  data: () => ({
    items: [
      {
        url: "https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-576p.mp4",
        time: 0,
      },
      {
        url: "https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-576p.mp4",
        time: 10,
      },
    ],
    currentUrl: "....",
  }),
  mounted() {
    // this.currentUrl = this.items[0].url + "#t=" + this.items[0].time;
    console.log(this.$refs.plyr.player);
    this.$refs.plyr.player.on("play", (e) => {
      console.log("play fired");
      console.log(e);
    });

    this.$refs.plyr.player.on("progress", (event) => {
      console.log("progress fired");
      console.log(event.timeStamp)
    });

    this.$refs.plyr.player.on("timeupdate", (e) => {
      console.log(e.timeStamp)
    });

    this.$refs.plyr.player.on("pause", (e) => {
      console.log("Pause fired")
      console.log(e.timeStamp)
    });

    this.$refs.plyr.player.on("ended", (e) => {
      console.log("Ended");
      // console.log(e.timeStamp)
      // this.$refs.plyr.player.stop();
      // this.currentUrl = this.items[0].url + '#t=' + this.items[0].time

      // document.getElementsByClassName("videoSource").src = this.items[1].url + '#t=' + this.items[1].time
      // this.$refs.plyr.player.play();
    });
  },
  created() {},
  methods: {
    clickToPlay: function (e) {
      console.log(e);
      this.currentUrl = e;
      // this.$refs.plyr.player.stop();
       var video = document.getElementById('videoSource');
   video.src = e;
   video.play();
      // document.getElementsByClassName("videoSource").src = e;
      // this.$refs.plyr.player.play();
    },
  },
};
</script>